<div class="rd-widget table-widget">
  <table class="widgetLeaseComparablesSummaryClass widget-large cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="64" class="widget-header-red" style="text-align: start;">
            <widget-value class="widget-header-red" [align]="'left'" [color]="'white'" [bold]="true">{{'leaseUpCosts.labelLeaseUpCostsTitle' | rdTranslate}}</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr class="dark-grey-line">
          <th scope="col" colspan="4">{{'leaseUpCosts.labelSpaceType' | rdTranslate}}</th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelSF' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelVacant' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelAnnual' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelRentSFUnit' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelExpense' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelRecovery' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelSFUnit' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelLease' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelTerm' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelFree' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelRent' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelLease' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelTIsSF' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelLCProcent' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelLC' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelCurrencySF' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelMonthsForgone' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelForgone' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelRent' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelExpense' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelRecovery' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelLoss' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelTIs' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelLoss' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelLC' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelLoss' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelFreRent' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelLoss' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="4">
            <div>{{'leaseUpCosts.labelTotal' | rdTranslate}}</div>
            <div>{{'leaseUpCosts.labelLoss' | rdTranslate}}</div>
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>
    <tbody class="extraTbody">

      <ng-container *ngFor="let entry of widgetData?.rows; let i = index">
        <dynamic-growth-row [row]="i + 3" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 !== 0)}">
            <td colspan="4"><widget-value [align]="'left'">{{entry.spaceType}}</widget-value></td>
            <td colspan="4">
              <widget-value [align]="'right'">{{entry.areaVacant}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{currency}}{{entry.annualRentPerAreaOrPerUnit| rdLocalizedNumber:2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{currency}}{{entry.expenseRecoveryPerAreaOrPerUnit| rdLocalizedNumber:2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{entry.leaseTermMos| rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{entry.freeRent| rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{currency}}{{entry.tisPerArea| rdLocalizedNumber:2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{entry.lcPercent * 100 | rdLocalizedNumber:2}}%</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{currency}}{{entry.lcPerArea| rdLocalizedNumber:2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{entry.monthsForgone| rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{currency}}{{entry.forgoneRent| rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{currency}}{{entry.expenseRecoveryLoss| rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{currency}}{{entry.tis| rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{currency}}{{entry.lc| rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{currency}}{{entry.freeRent| rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'right'">{{currency}}{{entry.total| rdLocalizedNumber:0}}</widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 3" [widget]="this">
        <tr>
          <td colspan="4">
            Totals/Averages
          </td>

          <td colspan="4">
            <widget-value [align]="'right'">{{widgetData?.totalsAverageAreaVacant| rdLocalizedNumber:0}}</widget-value>
          </td>
          <td colspan="36">
            <widget-value [align]="'right'">{{currency}}{{widgetData?.totalsAverageForgoneRent| rdLocalizedNumber:0}}</widget-value>
          </td>
          <td colspan="4">
            <widget-value [align]="'right'">{{currency}}{{widgetData?.totalsAverageExpenseRecoveryLoss| rdLocalizedNumber:0}}</widget-value>
          </td>
          <td colspan="4">
            <widget-value [align]="'right'">{{currency}}{{widgetData?.totalsAverageTIs| rdLocalizedNumber:0}}</widget-value>
          </td>
          <td colspan="4">
            <widget-value [align]="'right'">{{currency}}{{widgetData?.totalsAverageLC| rdLocalizedNumber:0}}</widget-value>
          </td>
          <td colspan="4">
            <widget-value [align]="'right'">{{currency}}{{widgetData?.totalsAverageFreeRent| rdLocalizedNumber:0}}</widget-value>
          </td>
          <td colspan="4">
            <widget-value [align]="'right'">{{currency}}{{widgetData?.totalsAverageTotal| rdLocalizedNumber:0}}</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 4" [widget]="this">
        <tr class="divider-bottom">
          <td colspan="30"><widget-value [align]="'left'">{{widgetData?.profitForLeaseUpRiskLabel}}</widget-value></td>
          <td colspan="34">
            <widget-value [align]="'right'">{{currency}}{{widgetData?.profitForLeaseUpRisk| rdLocalizedNumber:0}}</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 5" [widget]="this">
        <tr>
          <td colspan="60"><widget-value [align]="'left'">{{'leaseUpCosts.labelGrandTotal' | rdTranslate}}</widget-value></td>
          <td colspan="4">
            <widget-value [align]="'right'">{{currency}}{{widgetData?.grandTotal| rdLocalizedNumber:0}}</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 6" [widget]="this">
        <tr class="divider-bottom">
          <td colspan="60"><widget-value [align]="'left'">{{'leaseUpCosts.labelTotalPerAvailableSF' | rdTranslate}}</widget-value></td>
          <td colspan="4">
            <widget-value [align]="'right'">{{currency}}{{widgetData?.totalPerAvaiableArea| rdLocalizedNumber:0}}</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 7" [widget]="this">
        <tr>
          <td colspan="20"><widget-value [align]="'left'">{{'leaseUpCosts.labelTotalRentableArea' | rdTranslate}}</widget-value></td>
          <td colspan="4">
            <widget-value [align]="'right'">{{widgetData?.totalRentableAreaRatio * 100| rdLocalizedNumber:0}}%</widget-value>
          </td>
          <td colspan="4">
            <widget-value [align]="'right'">{{widgetData?.totalRentableArea| rdLocalizedNumber:0}}</widget-value>
          </td>
          <td colspan="36">
            &nbsp;
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 8" [widget]="this">
        <tr>
          <td colspan="20"><widget-value [align]="'left'">{{'leaseUpCosts.labelStabilizedOccupancy' | rdTranslate}}</widget-value></td>
          <td colspan="4">
            <widget-value [align]="'right'">{{widgetData?.stabilizedOccupancyRatio * 100| rdLocalizedNumber:0}}%</widget-value>
          </td>
          <td colspan="4">
            <widget-value [align]="'right'">{{widgetData?.stabilizedOccupancy| rdLocalizedNumber:0}}</widget-value>
          </td>
          <td colspan="36">
            &nbsp;
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 9" [widget]="this">
        <tr>
          <td colspan="20"><widget-value [align]="'left'">{{'leaseUpCosts.labelCurrentOccupancy' | rdTranslate}}</widget-value></td>
          <td colspan="4">
            <widget-value [align]="'right'">{{widgetData?.currentOccupancyRatio * 100| rdLocalizedNumber:0}}%</widget-value>
          </td>
          <td colspan="4">
            <widget-value [align]="'right'">{{widgetData?.currentOccupancy| rdLocalizedNumber:0}}</widget-value>
          </td>
          <td colspan="36">
            &nbsp;
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 10" [widget]="this">
        <tr>
          <td colspan="20"><widget-value [align]="'left'">{{'leaseUpCosts.labelSpaceToLeaseToStabilizedOccupancy' | rdTranslate}}</widget-value></td>
          <td colspan="4">
            <widget-value [align]="'right'">{{widgetData?.spaceToLeaseToStabilizedOccupancyRatio * 100| rdLocalizedNumber:2}}%</widget-value>
          </td>
          <td colspan="4">
            <widget-value [align]="'right'">{{widgetData?.spaceToLeaseToStabilizedOccupancy| rdLocalizedNumber:0}}</widget-value>
          </td>
          <td colspan="36">
            <widget-value [align]="'right'">{{widgetData?.spaceToLeaseToStabilizedOccupancyTotal| rdLocalizedNumber:0}}</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 11" [widget]="this">
        <tr>
          <td colspan="50"><widget-value [align]="'left'">{{'leaseUpCosts.labelTimesTotalLeaseUpCostsSF' | rdTranslate}}</widget-value></td>
          <td colspan="14">
            <widget-value [align]="'right'">{{currency}}{{widgetData?.timesTotalLeaseUpCostsPerArea| rdLocalizedNumber:0}}</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 12" [widget]="this">
        <tr>
          <td colspan="50"><widget-value [align]="'left'">{{'leaseUpCosts.labelTotalLeaseUpCostsToAchieveStabilizedOccupancy' | rdTranslate}}</widget-value></td>
          <td colspan="14">
            <widget-value [align]="'right'">{{currency}}{{widgetData?.totalLeaseUpCostsToAchieveStabilizedOccupancy| rdLocalizedNumber:0}}</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 13" [widget]="this">
        <tr>
          <td colspan="50"><widget-value [color]="'white'" [align]="'left'">{{'leaseUpCosts.labelRounded' | rdTranslate}}</widget-value></td>
          <td colspan="14">
            <widget-value [align]="'right'" [color]="'white'">{{currency}}{{widgetData?.rounded| rdLocalizedNumber:0}}</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
    </tbody>
  </table>
</div>

